import styled, { css } from 'styled-components'

const Container = styled.div`
  max-width: 1350px; /* 1290 + 30 + 30 */
  margin-left: auto;
  margin-right: auto;
  padding-left: 30px;
  padding-right: 30px;

  ${props =>
    props.spacing &&
    css`
      margin-bottom: 180px;
    `}

  ${props =>
    props.spacingSmall &&
    css`
      margin-bottom: 110px;

      @media (max-width: 580px) {
        margin-bottom: 55px;
      }
    `}

  ${props =>
    props.wide &&
    css`
      max-width: 1620px; /* 1560 + 30 + 30 */
      padding-left: 30px;
      padding-right: 30px;
    `}

  ${props =>
    props.noPadding &&
    css`
      padding-left: 0 !important;
      padding-right: 0 !important;
    `}

  @media (max-width: 660px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media (max-width: 460px) {
    padding-left: 16px;
    padding-right: 16px;
  }

  @media (max-width: 980px) {
    ${props =>
      props.outer &&
      css`
        padding-left: 0;
        padding-right: 0;
      `}
  }
`

export default Container
